import { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import Config from '../Config';
import { Update_User } from '../Redux/actions';

const useProfile = () => {
  const user = useSelector(state => state.UserReducer.user);
  const dispatch = useDispatch();
  const token = user?.token;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const fetchProfile = useCallback(async () => {
    if (!token) return;
    setError("");

    try {
      setLoading(true);
      const response = await axios.get(`${Config.apiUrl}/auth/profile`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const apiProfileData = response.data?.data?.user;

      if (apiProfileData) {
        dispatch(Update_User(apiProfileData));
        return apiProfileData;
      }
    } catch (err) {
      console.error('Profile fetch error:', err);
      setError('Failed to fetch profile');
    } finally {
      setLoading(false);
    }
  }, [token, dispatch]);

  const updateProfile = async (profilePayload) => {
    try {
      setLoading(true);
      setError('');

      const response = await axios.put(`${Config.apiUrl}/auth/profile`, profilePayload, {
        headers: { Authorization: `Bearer ${user?.token}` }
      });

      const updatedProfileData = response.data?.data?.user;
      const mergedProfileData = { ...user, ...updatedProfileData };

      dispatch(Update_User(mergedProfileData));

      setSuccess('Profile updated successfully!');
      setTimeout(() => setSuccess(''), 3000);

      // await fetchProfile();
      return true;

    } catch (err) {
      console.error('Profile update error:', err);
      if (err.response && err.response.data && err.response.data.errors) {
        throw err;
      } else {
        setError(err.response?.data?.errors && err.response.data.errors.length > 0 ? err.response.data.errors[0].message : 'Failed to update profile');
        throw err;
      }
    } finally {
      setLoading(false);
    }
  };

  const changePassword = async (passwordData) => {
    try {
      setLoading(true);
      setError('');
      await axios.post(`${Config.apiUrl}/auth/change-password`, passwordData, {
        headers: { Authorization: `Bearer ${user.token}` }
      });

      setSuccess('Password changed successfully!');
      setTimeout(() => setSuccess(''), 3000);
      return true;
    } catch (err) {
      setError(err.response?.data?.errors && err.response.data.errors.length > 0 ? err.response.data.errors[0].message : 'Failed to change password');
      console.error('Password change error:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    profileData: user,  // Return Redux user as profileData
    // setProfileData,
    loading,
    error,
    setError,
    success,
    setSuccess,
    fetchProfile,
    updateProfile,
    changePassword
  };
};

export default useProfile;
